(function () {
  // Tiroir du menu
  var tiroir = document.querySelector('[data-tiroir]');
  if (tiroir) {
    var ouvrir = document.querySelectorAll('[data-tiroir-ouvrir]');
    var fermer = tiroir.querySelectorAll('[data-tiroir-fermer]');
    var dernierFocus = null;

    function ouvrirTiroir() {
      dernierFocus = document.activeElement;
      tiroir.classList.add('est-ouvert');
      tiroir.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var premier = tiroir.querySelector('button, a');
      if (premier) premier.focus();
    }
    function fermerTiroir() {
      tiroir.classList.remove('est-ouvert');
      tiroir.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (dernierFocus) dernierFocus.focus();
    }

    ouvrir.forEach(function (b) { b.addEventListener('click', ouvrirTiroir); });
    fermer.forEach(function (b) { b.addEventListener('click', fermerTiroir); });
    tiroir.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', fermerTiroir); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && tiroir.classList.contains('est-ouvert')) fermerTiroir();
    });
  }

  // Sélecteur de variante (page produit)
  document.querySelectorAll('[data-variante-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      var prix = document.querySelector('[data-prix-produit]');
      if (prix && option.dataset.prix) prix.textContent = option.dataset.prix;
      var bouton = select.form.querySelector('[type="submit"]');
      if (bouton) {
        var dispo = option.dataset.dispo === 'true';
        bouton.disabled = !dispo;
        bouton.textContent = dispo ? bouton.dataset.texte : 'Épuisé';
      }
    });
  });

  // ---------- Recherche (avec suggestions en direct) ----------
  var recherche = document.querySelector('[data-recherche]');
  if (recherche) {
    var champ = recherche.querySelector('[data-recherche-champ]');
    var zone = recherche.querySelector('[data-recherche-resultats]');
    var minuterie = null;
    var controleur = null;

    function echapper(t) {
      return String(t || '').replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function ouvrirRecherche() {
      recherche.classList.add('est-ouvert');
      recherche.setAttribute('aria-hidden', 'false');
      setTimeout(function () { champ.focus(); }, 50);
    }
    function fermerRecherche() {
      recherche.classList.remove('est-ouvert');
      recherche.setAttribute('aria-hidden', 'true');
    }

    document.querySelectorAll('[data-recherche-ouvrir]').forEach(function (b) { b.addEventListener('click', ouvrirRecherche); });
    recherche.querySelectorAll('[data-recherche-fermer]').forEach(function (b) { b.addEventListener('click', fermerRecherche); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && recherche.classList.contains('est-ouvert')) fermerRecherche();
    });

    champ.addEventListener('input', function () {
      clearTimeout(minuterie);
      var q = champ.value.trim();
      if (q.length < 2) { zone.innerHTML = ''; return; }
      minuterie = setTimeout(function () {
        if (controleur) controleur.abort();
        controleur = new AbortController();
        var url = zone.dataset.url + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,page,article&resources[limit]=6&resources[options][fields]=title,body,product_type,variants.title';
        fetch(url, { signal: controleur.signal })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var res = (data && data.resources && data.resources.results) || {};
            var items = [];
            (res.products || []).forEach(function (p) { items.push({ titre: p.title, url: p.url, type: 'Produit', image: p.image }); });
            (res.pages || []).filter(function (p) { return String(p.url).indexOf('/pages/mamans-fondatrices') === -1; }).forEach(function (p) { items.push({ titre: p.title, url: p.url, type: 'Page' }); });
            (res.articles || []).forEach(function (a) { items.push({ titre: a.title, url: a.url, type: 'Article', image: a.image }); });
            if (!items.length) {
              zone.innerHTML = '<p class="recherche__vide">Aucun résultat pour « ' + echapper(q) + ' ».</p>';
              return;
            }
            zone.innerHTML = '<ul class="recherche__liste">' + items.map(function (i) {
              return '<li><a href="' + echapper(i.url) + '">' +
                (i.image ? '<img src="' + echapper(i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=96') + '" alt="" width="48" height="48" loading="lazy">' : '<span class="recherche__pastille" aria-hidden="true">✉</span>') +
                '<span><strong>' + echapper(i.titre) + '</strong><small>' + i.type + '</small></span></a></li>';
            }).join('') + '</ul>';
          })
          .catch(function () {});
      }, 220);
    });
  }

  // ---------- Bannière de cookies (API de confidentialité Shopify) ----------
  var banniere = document.querySelector('[data-cookies]');
  if (banniere) {
    var CLE = 'lpp-consentement';

    function lireChoix() { try { return localStorage.getItem(CLE); } catch (e) { return null; } }
    function garderChoix(v) { try { localStorage.setItem(CLE, v); } catch (e) {} }

    function montrer() { banniere.hidden = false; requestAnimationFrame(function () { banniere.classList.add('est-visible'); }); }
    function cacher() { banniere.classList.remove('est-visible'); setTimeout(function () { banniere.hidden = true; }, 300); }

    function envoyer(accepte) {
      garderChoix(accepte ? 'accepte' : 'refuse');
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && api.setTrackingConsent) {
        api.setTrackingConsent({
          analytics: accepte,
          marketing: accepte,
          preferences: accepte,
          sale_of_data: accepte
        }, function () {});
      }
      cacher();
    }

    function verifier() {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      var dejaChoisi = lireChoix();
      if (api && api.currentVisitorConsent) {
        var c = api.currentVisitorConsent() || {};
        if (c.analytics === '' || c.analytics === undefined) dejaChoisi = null;
      }
      if (!dejaChoisi || banniere.dataset.apercu === 'true') montrer();
    }

    banniere.querySelector('[data-cookies-accepter]').addEventListener('click', function () { envoyer(true); });
    banniere.querySelector('[data-cookies-refuser]').addEventListener('click', function () { envoyer(false); });
    document.querySelectorAll('[data-cookies-gerer]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); montrer(); });
    });

    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { verifier(); });
    } else {
      verifier();
    }
  }
})();

// ---------- Animations au défilement (rebond doux) ----------
(function () {
  var racine = document.documentElement;
  if (!racine.hasAttribute('data-animations')) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var cibles = [
    ['.en-tete-page__inner > *', ''],
    ['main .section__titre, main .section__intro, main .surtitre', ''],
    ['.etape, .formule, .carte-produit, .colonne, .temoignage, .galerie__item', 'pop'],
    ['.image-texte__image, .duo--gauche .duo__image', 'gauche'],
    ['.duo--droite .duo__image', 'droite'],
    ['.image-texte > div:last-child, .duo__texte, .recit, .texte-long__bloc, .faq details, .inscription, .offre, .contact, .appel, .banniere__carte, .liste-icones__item, .grille-produits', '']
  ];

  var vus = [];
  cibles.forEach(function (c) {
    document.querySelectorAll(c[0]).forEach(function (el) {
      if (el.closest('.heros') || el.closest('.anime') || vus.indexOf(el) > -1) return;
      vus.push(el);
      el.classList.add('anime');
      if (c[1]) el.classList.add('anime--' + c[1]);
      var parent = el.parentElement;
      if (parent) {
        var freres = Array.prototype.filter.call(parent.children, function (e) { return e.classList.contains('anime'); });
        var rang = freres.indexOf(el);
        if (rang > 0) el.style.setProperty('--delai', Math.min(rang * 0.09, 0.45) + 's');
      }
    });
  });

  var obs = new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) {
      if (e.isIntersecting) {
        var el = e.target;
        el.classList.add('est-visible');
        obs.unobserve(el);
        // Une fois arrivé, on retire l'animation pour que les survols restent vifs
        var fini = function (ev) {
          if (ev.target !== el || ev.propertyName !== 'transform') return;
          el.removeEventListener('transitionend', fini);
          el.classList.remove('anime', 'anime--pop', 'anime--gauche', 'anime--droite');
          el.style.removeProperty('--delai');
        };
        el.addEventListener('transitionend', fini);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  vus.forEach(function (el) { obs.observe(el); });

  // Dans l'éditeur Shopify, tout reste visible
  if (window.Shopify && window.Shopify.designMode) vus.forEach(function (el) { el.classList.add('est-visible'); });
  document.addEventListener('shopify:section:load', function () { document.querySelectorAll('.anime').forEach(function (el) { el.classList.add('est-visible'); }); });
})();
